import { create } from 'zustand';
import type { AuthUser } from '../services/api/authApiService';
import authApiService from '../services/api/authApiService';
import type { RegisterPayload, LoginPayload } from '../services/api/authApiService';

interface AuthState {
  user: AuthUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;

  login: (payload: LoginPayload) => Promise<AuthUser>;
  register: (payload: RegisterPayload) => Promise<AuthUser>;
  logout: () => Promise<void>;
  hydrate: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: false,

  hydrate: () => {
    const stored = localStorage.getItem('bts_user');
    const token = localStorage.getItem('bts_access_token');
    if (stored && token) {
      try {
        const user = JSON.parse(stored) as AuthUser;
        set({ user, isAuthenticated: true });
      } catch {
        set({ user: null, isAuthenticated: false });
      }
    }
  },

  register: async (payload) => {
    set({ isLoading: true });
    try {
      const res = await authApiService.register(payload);
      set({ user: res.user, isAuthenticated: true, isLoading: false });
      return res.user;
    } catch (err) {
      set({ isLoading: false });
      throw err;
    }
  },

  login: async (payload) => {
    set({ isLoading: true });
    try {
      const res = await authApiService.login(payload);
      set({ user: res.user, isAuthenticated: true, isLoading: false });
      return res.user;
    } catch (err) {
      set({ isLoading: false });
      throw err;
    }
  },

  logout: async () => {
    await authApiService.logout();
    set({ user: null, isAuthenticated: false });
  },
}));
